import { FC } from "react";
import { Content } from "~/components/content/Content";
import OrganizationProfileForm from "~/components/settings/OrganizationProfileForm";
import { SaveAction } from "~/dataProvider/types";
import { OrganizationProfileInput } from "~/gen/api/user";
import { OdResourcePageProps } from "~/types/resource";

export interface OrganizationProfileCreateBodyProps extends OdResourcePageProps {
  save: SaveAction<OrganizationProfileInput>;
}

const OrganizationProfileCreateBody: FC<OrganizationProfileCreateBodyProps> = ({
  save,
  options,
  resource,
}) => {
  
  return (
    <Content pageName="Organization Profile" resourceName={"My Organization"} breadcrumbs={options?.breadcrumbs}>
      <OrganizationProfileForm save={save} />
    </Content>
  )
}

export default OrganizationProfileCreateBody;
